import { Avatar } from '@mui/material';

const DEFAULT_AVATAR = process.env.PUBLIC_URL + '/images/default-avatar.jpg';

export const UserAvatar = ({ user, size, sx = {} }) => {
    return (
        <Avatar
            src={user?.profile?.profileImage || DEFAULT_AVATAR}
            alt={user?.profile?.nickname || 'ユーザー'}
            sx={{ width: size, height: size, ...sx }}
        />
    );
}; 